module.exports = __webpack_public_path__ + "assets/040fb7fb12c12e313eac7e79b0809297.svg";